import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=c8073e78&scoped=true"
import script from "./CustomerSearch.vue?vue&type=script&lang=ts"
export * from "./CustomerSearch.vue?vue&type=script&lang=ts"
import style0 from "./CustomerSearch.vue?vue&type=style&index=0&id=c8073e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8073e78",
  null
  
)

export default component.exports